import { SupportedPaymentMethods } from '../constants';

import {
  AffirmForm,
  BankForm,
  GenericCardForm,
  OxxoForm,
  PayPalForm,
  GooglePayForm,
} from './payment-methods';
import {
  CardMethodIcon,
  BankMethodIcon,
  PaypalMethodIcon,
  OxxoMethodIcon,
  AffirmMethodIcon,
  ApplePayMethodIcon,
  GooglePayMethodIcon,
} from './ui-elements/MethodIcon';

import type { PaymentMethodsType } from '../@types';
import type { ForwardRefExoticComponent } from 'react';
import type { CommonPaymentElementProps } from 'propTypes';

export type PaymentMethodRegistryType<P extends CommonPaymentElementProps = any> = Record<
  PaymentMethodsType,
  {
    Title: string,
    // TODO: Make components given here require certain props (e.g. onSubmit).
    Component: ForwardRefExoticComponent<P>,
    Icon: () => JSX.Element,
    hasAmount?: boolean,
  }
>;

export const PaymentMethodRegistry: Partial<PaymentMethodRegistryType> = {
  [SupportedPaymentMethods.CARD]: {
    Title: 'Card',
    Component: GenericCardForm,
    Icon: CardMethodIcon,
  },
  [SupportedPaymentMethods.PAYPAL]: {
    Title: 'Paypal',
    Component: PayPalForm,
    Icon: PaypalMethodIcon,
    hasAmount: true,
  },
  [SupportedPaymentMethods.BANK]: {
    Title: 'Bank Transfer',
    Component: BankForm,
    Icon: BankMethodIcon,
  },
  [SupportedPaymentMethods.OXXO]: {
    Title: 'OXXO',
    Component: OxxoForm,
    Icon: OxxoMethodIcon,
  },
  [SupportedPaymentMethods.AFFIRM]: {
    Title: 'Affirm',
    Component: AffirmForm,
    Icon: AffirmMethodIcon,
  },
  [SupportedPaymentMethods.APPLEPAY]: {
    Title: 'Apple Pay',
    Component: GooglePayForm,
    Icon: ApplePayMethodIcon,
    hasAmount: true,
  },
  [SupportedPaymentMethods.GOOGLEPAY]: {
    Title: 'Google Pay',
    Component: GooglePayForm,
    Icon: GooglePayMethodIcon,
    hasAmount: true,
  },
};
